/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_NoInputs */

const id_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak`)
};

const ms_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak`)
};

const da_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nej`)
};

const de_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein`)
};

const en_us2_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const es_es2_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const es_mx2_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const fil_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi`)
};

const fr_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const it_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const hu_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem`)
};

const nl_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee`)
};

const no_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nei`)
};

const pl_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie`)
};

const pt_br2_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const pt_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

const ro_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu`)
};

const fi_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei`)
};

const sv_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nej`)
};

const vi_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không`)
};

const tr_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hayır`)
};

const cs_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne`)
};

const bg_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не`)
};

const ru_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет`)
};

const uk_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ні`)
};

const ar_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا`)
};

const hi_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं`)
};

const th_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่`)
};

const ja_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ`)
};

const zh_cn2_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const zh_hant1_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const ko_forms_review_no = /** @type {(inputs: Forms_Review_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Forms_Review_NoInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_no = /** @type {((inputs?: Forms_Review_NoInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_NoInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_no(inputs)
	if (locale === "ms") return ms_forms_review_no(inputs)
	if (locale === "da") return da_forms_review_no(inputs)
	if (locale === "de") return de_forms_review_no(inputs)
	if (locale === "en-US") return en_us2_forms_review_no(inputs)
	if (locale === "es-ES") return es_es2_forms_review_no(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_no(inputs)
	if (locale === "fil") return fil_forms_review_no(inputs)
	if (locale === "fr") return fr_forms_review_no(inputs)
	if (locale === "it") return it_forms_review_no(inputs)
	if (locale === "hu") return hu_forms_review_no(inputs)
	if (locale === "nl") return nl_forms_review_no(inputs)
	if (locale === "no") return no_forms_review_no(inputs)
	if (locale === "pl") return pl_forms_review_no(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_no(inputs)
	if (locale === "pt") return pt_forms_review_no(inputs)
	if (locale === "ro") return ro_forms_review_no(inputs)
	if (locale === "fi") return fi_forms_review_no(inputs)
	if (locale === "sv") return sv_forms_review_no(inputs)
	if (locale === "vi") return vi_forms_review_no(inputs)
	if (locale === "tr") return tr_forms_review_no(inputs)
	if (locale === "cs") return cs_forms_review_no(inputs)
	if (locale === "bg") return bg_forms_review_no(inputs)
	if (locale === "ru") return ru_forms_review_no(inputs)
	if (locale === "uk") return uk_forms_review_no(inputs)
	if (locale === "ar") return ar_forms_review_no(inputs)
	if (locale === "hi") return hi_forms_review_no(inputs)
	if (locale === "th") return th_forms_review_no(inputs)
	if (locale === "ja") return ja_forms_review_no(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_no(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_no(inputs)
	return ko_forms_review_no(inputs)
});
export { forms_review_no as "forms.review.no" }